/**
 * Padrões de Etiquetas Industriais e Térmicas
 */
export const LABEL_SIZES = {
  '60x40': {
    id: '60x40',
    name: '60 × 40 mm (Padrão Marcenaria / Zebra)',
    widthMm: 60,
    heightMm: 40,
    recommendedFor: 'Térmica (Zebra, Elgin, Argox) para peças e sobras'
  },
  '50x50': {
    id: '50x50',
    name: '50 × 50 mm (Quadrada Compacta)',
    widthMm: 50,
    heightMm: 50,
    recommendedFor: 'Térmica quadrada para ferragens e estoque'
  },
  '100x50': {
    id: '100x50',
    name: '100 × 50 mm (Grande / Completa)',
    widthMm: 100,
    heightMm: 50,
    recommendedFor: 'Peças grandes de móveis com todas as fitas e QR Code'
  },
  '80x40': {
    id: '80x40',
    name: '80 × 40 mm (Média Retangular)',
    widthMm: 80,
    heightMm: 40,
    recommendedFor: 'Térmica retangular intermediária'
  }
};

/**
 * Abre janela de impressão isolada e sem cabeçalhos do navegador
 */
export const printThermalLabels = ({ htmlContent, sizeId = '60x40', title = 'Impressão de Etiquetas' }) => {
  const size = LABEL_SIZES[sizeId] || LABEL_SIZES['60x40'];
  const printWindow = window.open('', '_blank', 'width=650,height=750');
  if (!printWindow) {
    alert('Por favor, permita pop-ups no navegador para imprimir as etiquetas.');
    return;
  }

  const fullHtml = `
    <!DOCTYPE html>
    <html lang="pt-BR">
    <head>
      <meta charset="UTF-8">
      <title>${title}</title>
      <style>
        @page {
          size: ${size.widthMm}mm ${size.heightMm}mm;
          margin: 0;
        }
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        body {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
          background: #fff;
          color: #000;
          width: ${size.widthMm}mm;
          margin: 0 auto;
        }
        .thermal-label-page {
          width: ${size.widthMm}mm;
          height: ${size.heightMm}mm;
          max-height: ${size.heightMm}mm;
          padding: 1.8mm 2mm;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          page-break-after: always;
          page-break-inside: avoid;
          overflow: hidden;
          position: relative;
          background: #fff;
          border: 1px dashed #ccc; /* Visível na tela, some no corte real da bobina */
        }
        @media print {
          body {
            width: auto;
          }
          .thermal-label-page {
            border: none;
            page-break-after: always;
          }
        }
      </style>
    </head>
    <body>
      ${htmlContent}
      <script>
        window.onload = function() {
          setTimeout(function() {
            window.focus();
            window.print();
            window.close();
          }, 350);
        };
      </script>
    </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(fullHtml);
  printWindow.document.close();
};
